/** XML 문자열 이스케이프 */
export function escapeXml(str: string): string {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}

/** XML attribute 맵을 문자열로 변환 */
export function attrs(map: Record<string, string | number | boolean | undefined>): string {
  const parts: string[] = [];
  for (const [key, val] of Object.entries(map)) {
    if (val === undefined) continue;
    parts.push(`${key}="${escapeXml(String(val))}"`);
  }
  return parts.length > 0 ? ' ' + parts.join(' ') : '';
}

/** XML 요소 생성 헬퍼 */
export function el(
  tag: string,
  attributes: Record<string, string | number | boolean | undefined>,
  children?: string,
): string {
  const a = attrs(attributes);
  if (children === undefined || children === '') {
    return `<${tag}${a}/>`;
  }
  return `<${tag}${a}>${children}</${tag}>`;
}

/** XML 선언 */
export function xmlDecl(): string {
  return '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>';
}
